import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AvisoCertificadoComponent } from './aviso-certificado/aviso-certificado.component';

@NgModule({
  declarations: [
    AvisoCertificadoComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    AvisoCertificadoComponent
  ]
})
export class SmovaultModule { }
